import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class CreatePasswordService {

    constructor(private http: HttpClient) { }

    async create_password(email: string): Promise<{url: string}> {
        const payload = new HttpParams().set('email', email);        
        return await firstValueFrom(this.http.post<{url: string}>(`/admin/password`, payload));
    }
}